<template>
  <router-view/>
</template>

<script>

export default {
  name: 'LoggedOutLayout',
   components: {
    },
    props: {
       
    },
	data(){
		return {
           
		}
    },
    created() {
       
    },
	methods: {
       
    }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/shared/layouts/LoggedOutLayout.vue